import { LinearProgress } from "@mui/material";
import { type FC } from "react";
import { useLexicalContext } from "../../lexical-context";

export const ChannelDisplay: FC<{
  channel_id: string;
}> = ({ channel_id }) => {
  const {
    chatChannelRecipients: { data, loading },
  } = useLexicalContext();

  if (loading) return <LinearProgress />;

  const display = data?.find((r) => r.channel_id === channel_id)?.display;

  return <>{display ? `#${display}` : "⚠️ No channel found"}</>;
};
